export const initialState = {
  isFetched: false,
  id: null,
  name: null,
  price: null,
  discount: null,
  media: [],
  giftsetItems: [],
}


export const set = (state, payload /* item */) => ({
  ...initialState,
  ...payload,
  isFetched: true,
})
